<template>
  <div class="search-ads-campaigns">
    <div class="row align-middle">
      <div class="columns">
        <h2 class="search-ads-campaigns__overview-title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_OVERVIEW_TITLE') }}
        </h2>
      </div>
      <div class="columns shrink">
        <RangeFilter
          v-model="rangeFilter"
          :default-filters="campaignRangeFilters"
        />
      </div>
    </div>

    <SearchAdsCampaignsStats
      :update-controller="updateSearchAdsCampaignsController"
      :range="rangeFilter"
    />

    <header class="row align-middle search-ads-campaigns__header">
      <div class="columns large-expand small-12">
        <h2 class="search-ads-campaigns__title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_CAMPAIGNS') }}
        </h2>
      </div>
      <div class="columns shrink">
        <SearchAdsCampaignsCSVButton :range="rangeFilter" />
      </div>
    </header>

    <Card>
      <SearchAdsCampaignsList
        :update-controller="updateSearchAdsCampaignsController"
        :range="rangeFilter"
      />
    </Card>
  </div>
</template>

<script>
import Card from '@@/common/Card';
import RangeFilter from '@@/common/RangeFilter';
import SearchAdsCampaignsList from './SearchAdsCampaignsList';
import SearchAdsCampaignsStats from './SearchAdsCampaignsStats';
import SearchAdsCampaignsCSVButton from './SearchAdsCampaignsCSVButton';
import statsFilter from '@/mixins/statsFilter';
import createController from '@/utils/controller';
import { campaignTypes } from '../common/constants';
import { ALL_TIME } from '@/constant';

const updateSearchAdsCampaignsController = createController('update');

export default {
  name: 'SearchAdsCampaigns',
  components: {
    RangeFilter,
    SearchAdsCampaignsList,
    SearchAdsCampaignsStats,
    SearchAdsCampaignsCSVButton,
    Card,
  },
  mixins: [statsFilter],
  props: {
    updateController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rangeFilter: ALL_TIME,
    };
  },
  computed: {
    campaignRangeFilters() {
      return [
        {
          value: ALL_TIME,
          label: this.$t('ALL'),
        },
        ...this.getStatsRangeFilters(),
      ];
    },
    updateSearchAdsCampaignsController() {
      return updateSearchAdsCampaignsController;
    },
  },
  created() {
    this.updateController.onUpdate(this.checkAndGetCampaigns);
  },
  beforeDestroy() {
    this.updateController.removeOnUpdate(this.checkAndGetCampaigns);
  },
  methods: {
    checkAndGetCampaigns(campaignType) {
      if (campaignType === campaignTypes.SEARCH)
        this.updateSearchAdsCampaignsController.update();
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns {
  &__header {
    margin-bottom: $global-margin * 2.2;
  }

  &__overview-title,
  &__title {
    font-size: rem-calc(18px);
    margin: 0;
  }
}
</style>
